import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import DeviceTableDto from '../dto/DeviceTableDto';

class DeviceTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'deviceTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<DeviceTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, DeviceTableDto)))
				.catch(reject);
		});
	}
}

export default new DeviceTableService();
